var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Model, validator, createFunction, } from "@musicaudienceexchange/toccata";
const SearchActions = [
    'contacts',
    'events',
    'lead_sources',
];
export class SearchTokenRequest extends Model {
}
__decorate([
    validator.IsString(),
    validator.IsIn(SearchActions)
], SearchTokenRequest.prototype, "action", void 0);
__decorate([
    validator.IsString(),
    validator.IsOptional()
], SearchTokenRequest.prototype, "artistGroupId", void 0);
export class SearchTokenResponse extends Model {
}
__decorate([
    validator.IsString()
], SearchTokenResponse.prototype, "key", void 0);
__decorate([
    validator.IsNumber()
], SearchTokenResponse.prototype, "expires", void 0);
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function init(functions, createCallable) {
    return {
        searchToken: createFunction(functions, createCallable, 'auth-searchToken', SearchTokenRequest, SearchTokenResponse),
    };
}
//# sourceMappingURL=index.js.map